import { createAction, createRequestTypes, createRequestActions } from './utils';
export const LOAD_ATTRIBUTES = 'LOAD_ATTRIBUTES';
export const FETCH_ATTRIBUTES = 'FETCH_ATTRIBUTES';
export const UPDATE_ATTRIBUTES = 'UPDATE_ATTRIBUTES';
export const UPDATE_DEFAULT_PHONE_COUNTRY_CODE = 'UPDATE_DEFAULT_PHONE_COUNTRY_CODE';
export const UPDATE_PHONE_NUMBER = 'UPDATE_PHONE_NUMBER';
export const UPDATE_LANGUAGE = 'UPDATE_LANGUAGE';
export const UPDATE_LANGUAGE_WITH_LOCALE = 'UPDATE_LANGUAGE_WITH_LOCALE';
export const UPDATE_LOCALE = 'UPDATE_LOCALE';
export const UPDATE_LOCALE_WITH_LANGUAGE = 'UPDATE_LOCALE_WITH_LANGUAGE';
export const UPDATE_SIGNATURE_SUCCESS = 'UPDATE_SIGNATURE_SUCCESS';
export const UPDATE_UNSUBSCRIBE_TOGGLE = 'UPDATE_UNSUBSCRIBE_TOGGLE';
export const UPDATE_DEFAULT_HOME = 'UPDATE_DEFAULT_HOME';
export const FetchAttributesActionTypes = createRequestTypes(FETCH_ATTRIBUTES);
export const UpdateDefaultPhoneCountryCodeActionTypes = createRequestTypes(UPDATE_DEFAULT_PHONE_COUNTRY_CODE);
export const UpdatePhoneNumberActionTypes = createRequestTypes(UPDATE_PHONE_NUMBER);
export const UpdateLanguageWithLocaleActionTypes = createRequestTypes(UPDATE_LANGUAGE_WITH_LOCALE);
export const UpdateLocaleWithLanguageActionTypes = createRequestTypes(UPDATE_LOCALE_WITH_LANGUAGE);
export const UpdateDefaultHomeActionTypes = createRequestTypes(UPDATE_DEFAULT_HOME);
export const FetchAttributes = createRequestActions(FetchAttributesActionTypes);
export const UpdateDefaultPhoneCountryCode = createRequestActions(UpdateDefaultPhoneCountryCodeActionTypes);
export const UpdatePhoneNumber = createRequestActions(UpdatePhoneNumberActionTypes);
export const UpdateLanguageWithLocale = createRequestActions(UpdateLanguageWithLocaleActionTypes);
export const UpdateLocaleWithLanguage = createRequestActions(UpdateLocaleWithLanguageActionTypes);
export const UpdateDefaultHome = createRequestActions(UpdateDefaultHomeActionTypes);
export const loadAttributes = () => createAction(LOAD_ATTRIBUTES, {
  data: {
    hubless: false
  }
});
export const loadAttributesHubless = () => createAction(LOAD_ATTRIBUTES, {
  data: {
    hubless: true
  }
});
export const updateDefaultPhoneCountryCode = countryCode => createAction(UPDATE_DEFAULT_PHONE_COUNTRY_CODE, {
  data: countryCode
});
export const updatePhoneNumber = phoneNumber => {
  /*
   * Country codes are a max of 3 digits, because the PhonNumberInput always shows this code
   * we are considering that the user has deleted the phone number than we will have a length
   * of max 4 and so we can pass null to the endpoint to clean that saved number.
   */
  if (phoneNumber.length <= 4) {
    return createAction(UPDATE_PHONE_NUMBER, '');
  } else {
    return createAction(UPDATE_PHONE_NUMBER, {
      data: phoneNumber
    });
  }
};
export const updateLanguageAndLocale = localLangData => createAction(UPDATE_LANGUAGE, {
  data: localLangData
});
export const updateSignatureSuccess = () => createAction(UPDATE_SIGNATURE_SUCCESS);
export const updateUnsubscribeToggle = isToggledOn => createAction(UPDATE_UNSUBSCRIBE_TOGGLE, {
  data: isToggledOn
});
export const updateDefaultHome = homeKey => createAction(UPDATE_DEFAULT_HOME, {
  data: homeKey
});